function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
// kapigen version 0.1.12
// tslint:disable
import { google } from "../google";
import { Kaggle } from "../../sdk";
import { createClient } from "../../requestClientInternal";
import { UserWireFormat3 as KaggleSdkUsersUserWireFormat3 } from "../users";
export var AddLessonsToTrackRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCertificate = {
    authorUsername: "",
    courseName: "",
    fullUsername: "",
    gcsAccessImageUrl: "",
    isViewingOwnCertificate: false,
    trackId: 0,
    trackUrl: "",
    showOldCertificate: false,
    authorUsernames: []
};
export var CertificateWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCertificate, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.completionDate) {
            message.completionDate = new Date(wireFormat.completionDate);
        }
        return message;
    }
};
export var EditLessonRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetCertificateUploadUrlRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetCertificateUploadUrlResponse = {
    uploadUrl: ""
};
export var GetCertificateUploadUrlResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetCertificateUploadUrlResponse, wireFormat);
        return message;
    }
};
export var GetExerciseVersionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetExerciseVersionsResponse = {
    exerciseVersions: []
};
export var GetExerciseVersionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetExerciseVersionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.exerciseVersions) {
            message.exerciseVersions = wireFormat.exerciseVersions.map(function(i) {
                return LearnExerciseVersionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetTrackRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetTracksRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetTracksResponse = {
    tracks: []
};
export var GetTracksResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetTracksResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tracks) {
            message.tracks = wireFormat.tracks.map(function(i) {
                return LearnTrackWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultLearnExercise = {
    id: 0,
    scriptId: 0,
    name: "",
    url: "",
    authorUsername: "",
    scriptSlug: ""
};
export var LearnExerciseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLearnExercise, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.progress) != undefined) {
            message.progress = Number(wireFormat.progress);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastCompletionDate) {
            message.lastCompletionDate = new Date(wireFormat.lastCompletionDate);
        }
        return message;
    }
};
var defaultLearnExerciseVersion = {
    kernelVersionId: 0,
    questionCount: 0
};
export var LearnExerciseVersionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLearnExerciseVersion, wireFormat);
        return message;
    }
};
var defaultLearnHome = {
    tracks: [],
    recentlyProgressedTracks: []
};
export var LearnHomeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLearnHome, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tracks) {
            message.tracks = wireFormat.tracks.map(function(i) {
                return LearnTrackWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.recentlyProgressedTracks) {
            message.recentlyProgressedTracks = wireFormat.recentlyProgressedTracks.map(function(i) {
                return LearnTrackWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultLearnLesson = {
    id: 0,
    description: "",
    isExtraCredit: false
};
export var LearnLessonWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLearnLesson, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.learnTutorial) {
            message.learnTutorial = LearnTutorialWireFormat3.fromJson(wireFormat.learnTutorial);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.learnExercise) {
            message.learnExercise = LearnExerciseWireFormat3.fromJson(wireFormat.learnExercise);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSource) {
            message.dataSource = LearnLessonDataSourceWireFormat3.fromJson(wireFormat.dataSource);
        }
        return message;
    }
};
var defaultLearnLessonDataSource = {
    id: 0,
    url: "",
    thumbnailImageUrl: ""
};
export var LearnLessonDataSourceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLearnLessonDataSource, wireFormat);
        if (wireFormat) {
            message.type = LearnLessonDataSourceTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    }
};
var defaultLearnNudge = {
    courseIndex: 0,
    courseName: "",
    courseSlug: "",
    nextItemName: "",
    nextItemUrl: ""
};
export var LearnNudgeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLearnNudge, wireFormat);
        if (wireFormat) {
            message.nextItemType = LearnNudgeTypeWireFormat3.fromJson(wireFormat.nextItemType);
        }
        return message;
    }
};
var defaultLearnSeriesNavigationData = {};
export var LearnSeriesNavigationDataWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLearnSeriesNavigationData, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.learnCourse) {
            message.learnCourse = LearnTrackWireFormat3.fromJson(wireFormat.learnCourse);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.learnNudge) {
            message.learnNudge = LearnNudgeWireFormat3.fromJson(wireFormat.learnNudge);
        }
        return message;
    }
};
var defaultLearnTrack = {
    id: 0,
    trackIndex: 0,
    name: "",
    description: "",
    hasDailyDelivery: false,
    visible: false,
    trackSlug: "",
    thumbnailImageUrl: "",
    estimatedTimeHours: 0,
    userProgress: 0,
    certificateUrl: "",
    lessons: [],
    prerequisites: [],
    dependencyFor: [],
    authors: [],
    tags: [],
    forumId: 0
};
export var LearnTrackWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLearnTrack, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userProgress) != undefined) {
            message.userProgress = Number(wireFormat.userProgress);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lessons) {
            message.lessons = wireFormat.lessons.map(function(i) {
                return LearnLessonWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.prerequisites) {
            message.prerequisites = wireFormat.prerequisites.map(function(i) {
                return LearnTrackWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dependencyFor) {
            message.dependencyFor = wireFormat.dependencyFor.map(function(i) {
                return LearnTrackWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.authors) {
            message.authors = wireFormat.authors.map(function(i) {
                return KaggleSdkUsersUserWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tags) {
            message.tags = wireFormat.tags.map(function(i) {
                return Kaggle.Sdk.Tags.TagWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultLearnTutorial = {
    id: 0,
    scriptId: 0,
    name: "",
    url: "",
    authorDisplayName: "",
    authorUsername: "",
    scriptSlug: "",
    thumbnailImageUrl: ""
};
export var LearnTutorialWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLearnTutorial, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationDate) {
            message.creationDate = new Date(wireFormat.creationDate);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.progress) != undefined) {
            message.progress = Number(wireFormat.progress);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastCompletionDate) {
            message.lastCompletionDate = new Date(wireFormat.lastCompletionDate);
        }
        return message;
    }
};
var defaultLessonInfo = {
    tracks: []
};
export var LessonInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLessonInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tracks) {
            message.tracks = wireFormat.tracks.map(function(i) {
                return LearnTrackWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ReorderTracksRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultReorderTracksResponse = {
    tracks: []
};
export var ReorderTracksResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultReorderTracksResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tracks) {
            message.tracks = wireFormat.tracks.map(function(i) {
                return LearnTrackWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var RescoreExerciseVersionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultRescoreResponse = {
    affectedUsers: 0
};
export var RescoreResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRescoreResponse, wireFormat);
        return message;
    }
};
export var TrackEducationRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.type) {
            wireFormat.type = LearnTrackerStatusWireFormat3.toJson(message.type);
        }
        return wireFormat;
    }
};
export var TrackExerciseInteractionRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.interactionType) {
            wireFormat.interactionType = LearnExerciseInteractionTypeWireFormat3.toJson(message.interactionType);
        }
        if (message === null || message === void 0 ? void 0 : message.outcomeType) {
            wireFormat.outcomeType = LearnExerciseOutcomeTypeWireFormat3.toJson(message.outcomeType);
        }
        if (message === null || message === void 0 ? void 0 : message.questionType) {
            wireFormat.questionType = LearnExerciseQuestionTypeWireFormat3.toJson(message.questionType);
        }
        if ((message === null || message === void 0 ? void 0 : message.valueTowardsCompletion) != undefined && (message === null || message === void 0 ? void 0 : message.valueTowardsCompletion) != 0) {
            wireFormat.valueTowardsCompletion = Number.isFinite(message.valueTowardsCompletion) ? message.valueTowardsCompletion : Number(message.valueTowardsCompletion).toString();
        }
        return wireFormat;
    }
};
var defaultTrackExerciseInteractionResponse = {
    showLoginPrompt: false
};
export var TrackExerciseInteractionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTrackExerciseInteractionResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.nudge) {
            message.nudge = LearnNudgeWireFormat3.fromJson(wireFormat.nudge);
        }
        return message;
    }
};
export var LearnExerciseInteractionType;
(function(LearnExerciseInteractionType) {
    LearnExerciseInteractionType["UNSPECIFIED"] = "unspecified";
    LearnExerciseInteractionType["CHECK"] = "check";
    LearnExerciseInteractionType["HINT"] = "hint";
    LearnExerciseInteractionType["SOLUTION"] = "solution";
})(LearnExerciseInteractionType || (LearnExerciseInteractionType = {}));
export var LearnExerciseInteractionTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case LearnExerciseInteractionType.UNSPECIFIED:
            case 0:
            default:
                return "LEARN_EXERCISE_INTERACTION_TYPE_UNSPECIFIED";
            case LearnExerciseInteractionType.CHECK:
            case 1:
                return "CHECK";
            case LearnExerciseInteractionType.HINT:
            case 2:
                return "HINT";
            case LearnExerciseInteractionType.SOLUTION:
            case 3:
                return "SOLUTION";
        }
    }
};
export var LearnExerciseOutcomeType;
(function(LearnExerciseOutcomeType) {
    LearnExerciseOutcomeType["UNSPECIFIED"] = "unspecified";
    LearnExerciseOutcomeType["PASS"] = "pass";
    LearnExerciseOutcomeType["FAIL"] = "fail";
    LearnExerciseOutcomeType["EXCEPTION"] = "exception";
    LearnExerciseOutcomeType["UNATTEMPTED"] = "unattempted";
})(LearnExerciseOutcomeType || (LearnExerciseOutcomeType = {}));
export var LearnExerciseOutcomeTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case LearnExerciseOutcomeType.UNSPECIFIED:
            case 0:
            default:
                return "LEARN_EXERCISE_OUTCOME_TYPE_UNSPECIFIED";
            case LearnExerciseOutcomeType.PASS:
            case 1:
                return "PASS";
            case LearnExerciseOutcomeType.FAIL:
            case 2:
                return "FAIL";
            case LearnExerciseOutcomeType.EXCEPTION:
            case 3:
                return "EXCEPTION";
            case LearnExerciseOutcomeType.UNATTEMPTED:
            case 4:
                return "UNATTEMPTED";
        }
    }
};
export var LearnExerciseQuestionType;
(function(LearnExerciseQuestionType) {
    LearnExerciseQuestionType["UNSPECIFIED"] = "unspecified";
    LearnExerciseQuestionType["EQUALITY_CHECK_PROBLEM"] = "equalityCheckProblem";
    LearnExerciseQuestionType["CODING_PROBLEM"] = "codingProblem";
    LearnExerciseQuestionType["FUNCTION_PROBLEM"] = "functionProblem";
    LearnExerciseQuestionType["THOUGHT_EXPERIMENT"] = "thoughtExperiment";
})(LearnExerciseQuestionType || (LearnExerciseQuestionType = {}));
export var LearnExerciseQuestionTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case LearnExerciseQuestionType.UNSPECIFIED:
            case 0:
            default:
                return "LEARN_EXERCISE_QUESTION_TYPE_UNSPECIFIED";
            case LearnExerciseQuestionType.EQUALITY_CHECK_PROBLEM:
            case 1:
                return "EQUALITY_CHECK_PROBLEM";
            case LearnExerciseQuestionType.CODING_PROBLEM:
            case 2:
                return "CODING_PROBLEM";
            case LearnExerciseQuestionType.FUNCTION_PROBLEM:
            case 3:
                return "FUNCTION_PROBLEM";
            case LearnExerciseQuestionType.THOUGHT_EXPERIMENT:
            case 4:
                return "THOUGHT_EXPERIMENT";
        }
    }
};
export var LearnLessonDataSourceType;
(function(LearnLessonDataSourceType) {
    LearnLessonDataSourceType["UNSPECIFIED"] = "unspecified";
    LearnLessonDataSourceType["COMPETITION"] = "competition";
    LearnLessonDataSourceType["DATASET"] = "dataset";
})(LearnLessonDataSourceType || (LearnLessonDataSourceType = {}));
export var LearnLessonDataSourceTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "LEARN_LESSON_DATA_SOURCE_TYPE_UNSPECIFIED":
            default:
                return LearnLessonDataSourceType.UNSPECIFIED;
            case "COMPETITION":
                return LearnLessonDataSourceType.COMPETITION;
            case "DATASET":
                return LearnLessonDataSourceType.DATASET;
        }
    }
};
export var LearnNudgeType;
(function(LearnNudgeType) {
    LearnNudgeType["COURSE_COMPLETE_NO_BONUS_LESSONS"] = "courseCompleteNoBonusLessons";
    LearnNudgeType["COURSE_COMPLETE_WITH_BONUS_LESSONS"] = "courseCompleteWithBonusLessons";
    LearnNudgeType["COURSE_INCOMPLETE"] = "courseIncomplete";
    LearnNudgeType["DO_EXERCISE"] = "doExercise";
    LearnNudgeType["DO_TUTORIAL"] = "doTutorial";
})(LearnNudgeType || (LearnNudgeType = {}));
export var LearnNudgeTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "COURSE_COMPLETE_NO_BONUS_LESSONS":
            default:
                return LearnNudgeType.COURSE_COMPLETE_NO_BONUS_LESSONS;
            case "COURSE_COMPLETE_WITH_BONUS_LESSONS":
                return LearnNudgeType.COURSE_COMPLETE_WITH_BONUS_LESSONS;
            case "COURSE_INCOMPLETE":
                return LearnNudgeType.COURSE_INCOMPLETE;
            case "DO_EXERCISE":
                return LearnNudgeType.DO_EXERCISE;
            case "DO_TUTORIAL":
                return LearnNudgeType.DO_TUTORIAL;
        }
    }
};
export var LearnTrackerStatus;
(function(LearnTrackerStatus) {
    LearnTrackerStatus["UNSPECIFIED"] = "unspecified";
    LearnTrackerStatus["TRACK_VIEW"] = "trackView";
    LearnTrackerStatus["KERNEL_VIEW"] = "kernelView";
    LearnTrackerStatus["PAGE_VIEW"] = "pageView";
    LearnTrackerStatus["EXERCISE_FORK"] = "exerciseFork";
})(LearnTrackerStatus || (LearnTrackerStatus = {}));
export var LearnTrackerStatusWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case LearnTrackerStatus.UNSPECIFIED:
            case 0:
            default:
                return "LEARN_TRACKER_STATUS_UNSPECIFIED";
            case LearnTrackerStatus.TRACK_VIEW:
            case 1:
                return "TRACK_VIEW";
            case LearnTrackerStatus.KERNEL_VIEW:
            case 2:
                return "KERNEL_VIEW";
            case LearnTrackerStatus.PAGE_VIEW:
            case 3:
                return "PAGE_VIEW";
            case LearnTrackerStatus.EXERCISE_FORK:
            case 4:
                return "EXERCISE_FORK";
        }
    }
};
export var educationClient = {
    educationService: {
        addLessonsToTrack: createClient(AddLessonsToTrackRequestWireFormat3, LearnTrackWireFormat3, "education.EducationService/AddLessonsToTrack"),
        editLesson: createClient(EditLessonRequestWireFormat3, LearnLessonWireFormat3, "education.EducationService/EditLesson"),
        getCertificateUploadUrl: createClient(GetCertificateUploadUrlRequestWireFormat3, GetCertificateUploadUrlResponseWireFormat3, "education.EducationService/GetCertificateUploadUrl"),
        getExerciseVersions: createClient(GetExerciseVersionsRequestWireFormat3, GetExerciseVersionsResponseWireFormat3, "education.EducationService/GetExerciseVersions"),
        getTrack: createClient(GetTrackRequestWireFormat3, LearnTrackWireFormat3, "education.EducationService/GetTrack"),
        getTracks: createClient(GetTracksRequestWireFormat3, GetTracksResponseWireFormat3, "education.EducationService/GetTracks"),
        reorderTracks: createClient(ReorderTracksRequestWireFormat3, ReorderTracksResponseWireFormat3, "education.EducationService/ReorderTracks"),
        rescoreExerciseVersion: createClient(RescoreExerciseVersionRequestWireFormat3, RescoreResponseWireFormat3, "education.EducationService/RescoreExerciseVersion"),
        trackEducation: createClient(TrackEducationRequestWireFormat3, google.protobuf.EmptyWireFormat3, "education.EducationService/TrackEducation"),
        trackExerciseInteraction: createClient(TrackExerciseInteractionRequestWireFormat3, TrackExerciseInteractionResponseWireFormat3, "education.EducationService/TrackExerciseInteraction")
    }
};
